import React from "react";
const Registerslider = (props) => {
  return (
    <div
      className="xs:w-24 xs:h-24 sm:w-32 sm:h-32 lg:w-40 rounded-full lg:h-40 flex justify-center items-start overflow-hidden"
      style={{ backgroundColor: props.bgColor }}
    >
      <img
        src={props.image}
        className="w-[90%] h-[90%] object-contain"
        alt="eventthubmail"
      />
    </div>
  );
};
export default Registerslider;
